import api from './api';
import type { Lesson, Comment } from '../types';

export interface AddCommentData {
  comment_text: string;
  slide_number?: number;
}

export const reviewService = {
  getPendingReviews: async (): Promise<Lesson[]> => {
    const response = await api.get<{ lessons: Lesson[] }>('/reviews/pending');
    return response.data.lessons ?? [];
  },

  getComments: async (lessonId: string, version: number): Promise<Comment[]> => {
    const response = await api.get<{ comments: Comment[] }>(
      `/lessons/${lessonId}/versions/${version}/comments`
    );
    return response.data.comments ?? [];
  },

  addComment: async (
    lessonId: string,
    version: number,
    data: AddCommentData
  ): Promise<Comment> => {
    const response = await api.post<Comment>(
      `/lessons/${lessonId}/versions/${version}/comments`,
      data
    );
    return response.data;
  },

  approve: async (lessonId: string, version: number): Promise<void> => {
    await api.post(`/lessons/${lessonId}/versions/${version}/approve`);
  },

  reject: async (lessonId: string, version: number, reason: string): Promise<void> => {
    await api.post(`/lessons/${lessonId}/versions/${version}/reject`, {
      reason,
    });
  },
};
